import { useRef, useState, useLayoutEffect } from 'react';
import { toInteger } from 'lodash';

// Import helpers
import { useEventListener } from 'components/utilities';

function useElementDimensions() {
	const elementRef = useRef();
	const [width, setWidth] = useState(0);
	const [height, setHeight] = useState(0);
	const isLoaded = elementRef.current && width > 0 && height > 0;

	const getElementDimensions = () => {
		if (elementRef.current) {
			setWidth(toInteger(elementRef.current.offsetWidth));
			setHeight(toInteger(elementRef.current.offsetHeight));
		} else {
			setWidth(0);
			setHeight(0);
		}
	};

	const getResizeUrl = (aspectRatio) => {
		if (!!aspectRatio) return `=w${width}-h${toInteger(width / aspectRatio)}`;
		return `=w${width}-h${height}`;
	};

	useEventListener('resize', getElementDimensions, elementRef.current);

	useLayoutEffect(() => {
		if (elementRef.current) getElementDimensions();
	}, [elementRef]);

	return {
		elementRef,
		width,
		height,
		getResizeUrl,
		isLoaded
	};
}

export default useElementDimensions;
